function easterReveal() {
  const reveal = document.getElementById("revealBox"); 
  reveal.classList.add('clicked');
  
  const egg = document.getElementById("easter-egg-hide");  
  egg.classList.remove('hidden');

  const footer = document.getElementsByTagName("footer"); 
  for (i = 0; i < footer.length; i++) {
    footer[i].classList.add("easter-egg");
  }
  
  const element = document.getElementById("screen_two");  
  element.classList.add('hidden');

  const start = document.getElementById("screen_one");    
  start.classList.remove("hidden");
  start.scrollIntoView();
  
}

function returnToTop() {

  window.scrollTo({ top: 0, behavior: 'smooth' });

  const reveal = document.getElementById("revealBox"); 
  reveal.classList.remove('clicked');
  
  const egg = document.getElementById("easter-egg-hide");  
  egg.classList.add('hidden');

}

const sleep = timeout => new Promise(resolve => setTimeout(resolve, timeout))

function easterScroll() {

  const oldElement = document.getElementById("screen_one");  
  oldElement.classList.add('hidden');
  
  const element = document.getElementById("screen_two");  
  element.classList.remove('hidden');
  element.scrollIntoView();

  setTimeout(function(){
    var lineItem = document.querySelectorAll('.playing_card')

    async function loop() {
      for (let i = lineItem.length - 1; i >= 0; i--) {
        lineItem[i].className  += " visible"
        await sleep(300)
      }
    }
    loop()
  }, 500);

  setTimeout(function(){
    const activeCard = document.getElementById("activeCard");
    activeCard.classList.add('active');
  }, 2500);

  setTimeout(function(){
    const activeCard = document.getElementById("toReveal");
    activeCard.classList.add('revealed');
  }, 3500);
}




if(window.location.href.indexOf("customer#confirmation") != -1){

  window.addEventListener('DOMContentLoaded', (event) => {

    const egg = document.getElementById("easter-egg-hide"); 
    const screenOne = document.getElementById("screen_one"); 
    const screenTwo = document.getElementById("screen_two");
    const screenThree = document.getElementById("screen_three"); 
     
    egg.classList.remove('hidden');
    screenOne.classList.add('hidden');
    screenTwo.classList.add('hidden');
    screenThree.classList.remove('hidden');

    screenThree.scrollIntoView();
    
  });
  
}